import Vue from 'vue'

import FileInput from './file-input'
Vue.component('file-input', FileInput)

import HvdQrcode from './hvd-qrcode'
Vue.component('hvd-qrcode', HvdQrcode)

import InputDateRange from './input-date-range'
Vue.component('input-date-range', InputDateRange)

import InputDate from './input-date'
Vue.component('input-date', InputDate)

import InputDatetimeRange from './input-datetime-range'
Vue.component('input-datetime-range', InputDatetimeRange)

import InputDatetime from './input-datetime'
Vue.component('input-datetime', InputDatetime)

import MeineVisitenkarte from './meine-visitenkarte'
Vue.component('meine-visitenkarte', MeineVisitenkarte)

import RadioGroup from './radio-group'
Vue.component('radio-group', RadioGroup)

import SelectPerson from './select-person'
Vue.component('select-person', SelectPerson)

import TiptapInput from './tiptap-input'
Vue.component('tiptap-input', TiptapInput)
